import { createContext, useContext, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment'
import { POST_ADD_SOLD_ITEMS, POST_CLOSE_ORDER, POST_SEND_MESSAGE, POST_START_ORDER, POST_UPDATE_ORDER } from '../services/orderService';
import { getPriceWithDiscountList } from '../utils/getPriceWithDiscount';


const CartContext = createContext();

const orderInitialState = {
  orderId: null,
  deliveryDay: null,
  priceListCode: null,
  routeName: null,
  totalPriceWithoutDiscount: null,
  update: {
    orderId: null,
    products: [],
    totalDiscount: null,
    totalPayment: null,
    totalPrice: null,
    totalTaxes: null,
    Total: null,
    SubTotal: null,
    DiscountFirstPurchase: null,
    DiscountProduct: null,
  }
}


export const CartContextProvider = ({ children }) => {
  const [chart, setChart] = useState({
    products: [],
    checkingProducts: [],
    orderConfirmed: false,
    orderError: false,
    progress: 0
  });

  const [stepper, setStepper] = useState(0)

  const [loadingOrder, setLoadingOrder] = useState(false)

  const [order, setOrder] = useState(orderInitialState)

  const { products, Promotions } = chart;

  const setProgress = (newProgress) => {
    setChart({ ...chart, progress: newProgress });
  };

  const resetStepper = () => {
    setStepper(0)
  }

  const nextStepper = () => {
    setStepper(stepper + 1)
  }

  const backStepper = () => {
    setStepper(stepper - 1)
  }

  const addProductToChartAction = (product, amount) => {
    console.log("newProducts1: ", chart);
    let exists = products.find((prod) => prod.product.code === product.code);
    let newProducts = products;
    if (exists) {
      newProducts = products.map((prod) => (prod.product.code === product.code ? { product: prod.product, amount: prod.amount + 1, promotionChecked: prod.promotionChecked } : prod));
    } else {
      newProducts.push({ product: { ...product }, amount: amount, promotionChecked: (product.promotions?.length ?? 0) > 0 });
      toast.success(<p style={{ fontFamily: 'AmsiPro' }}>Se añadió Promo<span style={{ fontWeight: '700' }}>{product.name}</span> correctamente!</p>);
    }
    setChart((st) => ({
      ...st,
      products: newProducts,
    }));
    localStorage.setItem('chartProducts', JSON.stringify(newProducts));
  };


  const updateProductToChartAction = (product, amount) => {
    let newProducts = products; // <-- Copia inmutable
    console.log("carrito1: ", newProducts);
    const productsArrayUpdate = [product];
    const productsArrayDelete = [];
    const PromotionArray = [];
    const PromotionTotal = [];
    const priceWithDiscountList = getPriceWithDiscountList(product, amount, products, 0);

    if (amount == 0) {
      // console.log('deleteProductFromChartAction - chart:', getState().chart)
      newProducts = chart.products.filter((item) => !item.product.code.includes(product.code)
        && !item.product.skuId.includes(product.skuId));
    }
    else {

      const discountPrice2 = priceWithDiscountList.PriceWithDiscount;
      product.discountPrice = discountPrice2;
      product.amount = amount === '' ? amount : Number(amount);
      //console.log("priceWithDiscount-: ", priceWithDiscountList);
      let productsfilter = JSON.parse(localStorage.getItem('products')) || '[]';
      priceWithDiscountList.Gifts.forEach((priceWithDiscount, index) => {
        console.log(`GiftSKU-: ${priceWithDiscount.GiftSKU}, Quantity: ${priceWithDiscount.GiftQuantity}, DiscountValue: ${priceWithDiscount.DiscountValue}, giftAdd: ${priceWithDiscount.giftAdd}`);
        let productPromo = structuredClone(productsfilter.find((prod) => prod.code === priceWithDiscount.GiftSKU));
        //console.log("productPromo1: ", productPromo);
        //let productPromo = productsfilter.find((prod) => prod.code === itemp.GiftSKU);
        //console.log("item.product: ", item.product);
        if (productPromo) {
          //console.log("productPromo1-: ", productPromo);
          let prom = structuredClone(product.promotions[0]);
          //console.log("prom: ", prom);
          productPromo.code = productPromo.code + '_' + prom.code + '_GIFT';
          productPromo.skuId = productPromo.skuId + '_' + product.skuId + '_GIFT';
          productPromo.ProductType = 'PROMO';
          productPromo.bGift = true;
          productPromo.promotions = [{
            code: prom.code, promoType: "REGULAR", Description: prom.Description,
            Description: prom.Description, timeStart: prom.timeStart, timeEnd: prom.timeEnd,
            dateStart: prom.dateStart, dateEnd: prom.dateEnd, promotion: prom.promotion,
            StockPerCustomer: Number.MAX_SAFE_INTEGER, StockPerStore: Number.MAX_SAFE_INTEGER,
            DiscountDetail: { DiscountType: 'PERCENTAGE', DiscountValue: priceWithDiscount.DiscountValue }
          }];
          if (priceWithDiscount.giftAdd) {
            productPromo.amount = priceWithDiscount.GiftQuantity;
            productPromo.discountPrice = productPromo.salePrice - (priceWithDiscount.DiscountValue * productPromo.salePrice / 100);
            console.log('productPromo:', productPromo)
            productsArrayUpdate.push(productPromo);
            // updateProductToChartAction(productPromo, (priceWithDiscount.giftAdd ? priceWithDiscount.GiftQuantity : 0), priceWithDiscount.DiscountValue);
          }
          else {
            productsArrayDelete.push(productPromo);
            // deleteProductFromChartAction(productPromo);
          }

        }

      });
    }


    //console.log("carrito2: ", newProducts);
    //console.log("productsArrayUpdate: ", productsArrayUpdate);
    productsArrayUpdate.forEach((x, i) => {
      let exists = products.find((prod) => prod.product.code === x.code);
      //console.log("exists: ", exists);
      //console.log('Valor de x.discountPrice:', x.discountPrice);
      if (exists) {
        newProducts = newProducts.map((prod) => (prod.product.code === x.code
          ? {
            product: x,
            discountPrice: x.discountPrice,
            amount: x.amount === '' ? x.amount : Number(x.amount),
            promotionChecked: prod.promotionChecked
          }
          : prod));
      } else {
        newProducts.push({
          product: { ...x },
          discountPrice: x.discountPrice,
          amount: x.amount,
          promotionChecked: x?.promotions?.length > 0
        });
      }
    })
    //console.log("carrito3: ", newProducts);

    productsArrayDelete.forEach((x, i) => {
      newProducts = newProducts.filter((y) => !y.product.code.includes(x.code));
    });
    newProducts = newProducts.filter((y) => y != null && y != undefined);
    console.log("---INI---");
    // guardar lista de promociones. (CODE, cantidad items, monto total)
    console.log("carrito: ", newProducts);

    // Procesar surtidos
    newProducts.forEach((item) => {
      const salePrice = item.product.salePrice;
      if (item.product.promotions && item.product.ProductType == 'BASE') {
        item.product.promotions.forEach((promo) => {
          const promoCode = promo.code;
          // Calcular el subtotal
          const subtotal = item.amount * salePrice;
          // Buscar si la promoción ya existe en el array
          const existingPromo = PromotionTotal.find((p) => p.code === promoCode);

          if (existingPromo) {
            // Si existe, actualizar sus valores
            existingPromo.amountTotal += item.amount;
            existingPromo.Total += subtotal;
          } else {
            // Si no existe, agregar la promoción al array
            PromotionTotal.push({
              code: promoCode,
              MinValue: promo.Conditions?.ItemValueRange?.MinValue,
              MaxValue: promo.Conditions?.ItemValueRange?.MaxValue,
              TypeValue: promo.Conditions?.ItemValueRange?.TypeValue,
              promoType: promo.promoType,
              DiscountType: promo?.DiscountDetail?.DiscountType,
              amountTotal: item.amount, // Inicializar amountTotal
              Total: subtotal, // Inicializar total
              MaxUsed: 0,
              TotalUsed: 0,
            });
          }
        });
      }
    });

    let promoused = 0;
    const finalProducts = newProducts.map(x => {
      console.log("producto-promo ", x.product.code);
      const valor = (x.product.code == product.code && priceWithDiscountList.arrpromotioncode.length == 0) ? promoused : promoused;
      //actuualizar Maximo, pero incrementando el contador para surtidos
      PromotionTotal.forEach(promox => {
        let promoexists = PromotionTotal?.find((promoe) => promoe.code === promox.code);
        promoexists.MaxUsed += x.amount;
        promoexists.TotalUsed += (x.amount * x.product.salePrice);
      });

      const priceWithDiscountListx = getPriceWithDiscountList(x.product, x.amount, newProducts, valor, structuredClone(PromotionTotal));
      // Verificar si hay códigos de promoción
      if (priceWithDiscountListx.arrpromotioncode.length > 0) {
        if (valor != Number.MAX_SAFE_INTEGER && priceWithDiscountListx.AplicaPromo == true) {
          promoused++;
          console.log("APLICA PROMO ", promoused);
          priceWithDiscountListx.arrpromotioncode.forEach(promo => {
            PromotionArray.push({ ...promo });
          });
        }
        else {
          console.log("NO APLICA PROMO ");
        }
        console.log("------");
      }
      // Asignar el precio con descuento al producto
      const discountPricex = priceWithDiscountListx.PriceWithDiscount;
      x.discountPrice = discountPricex;
      const productType = x.product.ProductType;
      //K000085_20250329043052128_GIFT -> 20250329043052128
      const promoCodeByProductCode = x.product.promotions?.find(y => x.product.code.search(y))?.code
      if(productType == 'PROMO' && promoCodeByProductCode){
        x.promotionIds = promoCodeByProductCode;
      }
      else {
        x.promotionIds = x.product.salePrice > priceWithDiscountListx.PriceWithDiscount ? 
          priceWithDiscountListx.arrpromotioncode?.map(x => x.promocode).join(",") : '';
      }
      
      return x;
    });
    console.log("---FIN---");
    localStorage.setItem('chartProducts', JSON.stringify(finalProducts));
    console.log("PromotionArray2: ", PromotionArray);
    setChart((prev) => {
      return {
        ...prev,
        products: finalProducts,
        Promotions: PromotionArray,
      }
    });
  };

  const RefreshProductToChartAction = (product) => {
    //console.log('update cart:', products);
    //console.log('Product2:', product);

    products.forEach((item) => {
      console.log('item:', item);
      let exists = product.find((prod) => prod.code === item.product.code);
      item.discountPrice = exists.salePrice ?? 0;
      item.product = exists;
      console.log('ex:', exists);

      // if (item.product.code === product.code) {
      //   item.amount = amount;
      // }
    });

    //updateProductToChartAction(product, 0);

    //setChart({ ...chart, products: chartProducts });
    setChart((st) => ({
      ...st,
      products: products,
    }));
    localStorage.setItem('chartProducts', JSON.stringify(products));


  };


  const deleteProductFromChartAction = async (product) => {
    try {
      // console.log('deleteProductFromChartAction - chart:', getState().chart)
      let newProducts = chart.products.filter((item) => !item.product.code.includes(product.code));
      console.log("newProduct2: ", newProducts);
      // dispatch({
      // 	type: DELETE_EXISTING_PRODUCT,
      // 	payload: {
      // 		chartProducts: newProducts,
      // 	},
      // });
      setChart({ ...chart, products: newProducts });
      console.log('deleteProductFromChartAction ', newProducts)
      localStorage.setItem('chartProducts', JSON.stringify(newProducts));
    } catch (error) {
      console.log(error);
    }
  };

  const substractProductToChartAction = async (product, amount) => {
    try {
      // console.log('substractProductToChartAction - chart: ', getState().chart)
      // console.log('substractProductToChartAction - product.code: ', product.code)
      // console.log('substractProductToChartAction - amount: ', amount)

      let chartProducts = chart.products.slice();
      console.log("CartContext-substractProductToChartAction: ", product);
      chartProducts.forEach((item) => {
        if (item.product.code === product.code) {
          item.amount = amount;
        }
      });

      // console.log('substractProductToChartAction - chart modified: ', chartProducts)

      // dispatch({
      // 	type: SUBSTRACT_EXISTING_PRODUCT_EXITO,
      // 	payload: { chartProducts: chartProducts },
      // });
      setChart({ ...chart, products: chartProducts });

      localStorage.setItem('chartProducts', JSON.stringify(chartProducts));
    } catch (error) {
      console.log(error);
    }
  };

  const handleStartOrderAndUpdateOrder = async (user, totalPrice) => {
    try {
      setLoadingOrder(true)
      console.log('sip1: ', totalPrice);
      //AQUI CAMBIAR LA DIRECCION DEL CLIENTE
      const startOrderParameters = {
        orderId: '',
        companyId: '1',
        clientId: user.odooClientCode,
        addressId: user.addressId,
        dayToDelivery: user.dayToDelivery,
        dayOfWeek: user.dayOfWeek,
        Contact: user.Contact,
        discountProducts: totalPrice.discountProducts,
        discountFirstPurchase: totalPrice.discountFirstPurchase,
        deliveryAdress: {
          address: '',
          city: '',
          country: '',
          district: '',
          latitude: '',
          longitude: '',
          number: '',
          street: '',
        },
        date: moment().tz('America/Lima').format('DD/MM/YYYY').toString(),
        sellingConditionId: '001',
        // priceListId: user.deliveryAddresses.filter((item) => item.code === user.addressId)[0].priceListCode,
        // storageId: user.storageId,
        // sellerId: user.deliveryAddresses.filter((item) => item.code === user.addressId)[0].sellerCode,
        // routeId: user.deliveryAddresses.filter((item) => item.code === user.addressId)[0].routeId,
        // latitude: '' + user.deliveryAddresses.filter((item) => item.code === user.addressId)[0].latitude,
        // longitude: '' + user.deliveryAddresses.filter((item) => item.code === user.addressId)[0].longitude,
        status: '0',
        clientMobilePhone: user.mobilePhone,
        routes: user.routes,
      }




      let totalPriceWithoutDiscount = 0;

      const products = chart.products.map(item => {

        totalPriceWithoutDiscount += parseFloat((item.amount * item.product.salePrice).toFixed(1));

        return {
          productId: item.product.code,
          taxId: item.product.taxId ?? 0,
          amount: item.amount,
          type: 'N',
          shortName: item.product.shortName,
          unitPrice: item.product.salePrice,
          DiscountPrice: item.product.discountPrice ?? 0,
          promotionIds: item.promotionIds ?? '',
          finalPrice: Number((item.amount * item.product.salePrice).toFixed(1)),
          //PromotionCode : item.product.
          //AQUI ENVIAR LA PROMOCION
        }
      })

      // const updateOrderParameters = {
      //   companyId: '1',
      //   orderId: startOrderResponse.orderId,
      //   products: products,
      //   clientMobilePhone: user.mobilePhone,
      // }


      console.log('totalPriceWithoutDiscount: ', totalPriceWithoutDiscount);
      startOrderParameters.products = products;
      startOrderParameters.promotions = chart.Promotions;
      console.log('startOrderParameters: ', startOrderParameters);
      const startOrderResponse = await POST_START_ORDER(startOrderParameters);


      // const updateOrderResponse = await POST_UPDATE_ORDER(updateOrderParameters)

      setOrder({
        ...startOrderResponse,
        totalPriceWithoutDiscount,
        update: {
          ...startOrderResponse
        }
      })

      setLoadingOrder(false)

    } catch (error) {
      setLoadingOrder(false)
      resetStepper();
      console.error(error);
    }
  }

  const handleCloseOrder = async (user) => {
    try {

      setLoadingOrder(true);

      const closeOrderParameters = {
        companyId: '1',
        orderId: order.orderId,
        confirmFlag: '1',
        clientMobilePhone: user.mobilePhone
      }

      await POST_CLOSE_ORDER(closeOrderParameters);


      const updateOrderInfo = { ...order.update };

      updateOrderInfo.deliveryDay = order.deliveryDay;
      updateOrderInfo.deliveryHour = user.schedule;
      updateOrderInfo.routeName = order.routeName;
      updateOrderInfo.priceListCode = order.priceListCode;


      const sendMessageParameters = {
        companyId: '1',
        orderId: order.orderId,
        confirmFlag: '1',
        clientMobilePhone: user.mobilePhone
      }

      //sendMessageParameters.products = products;
      await POST_SEND_MESSAGE(sendMessageParameters)

      setChart({ ...chart, products: [] });
      localStorage.removeItem('chartProducts');
      setLoadingOrder(false)
    } catch (error) {

      setLoadingOrder(false)
      resetStepper();
      console.error(error);
    }
  }



  return (
    <CartContext.Provider
      value={{
        chart,
        setChart,
        addProductToChartAction,
        deleteProductFromChartAction,
        substractProductToChartAction,
        updateProductToChartAction,
        RefreshProductToChartAction,
        setProgress,
        stepper,
        setStepper,
        resetStepper,
        nextStepper,
        backStepper,
        loadingOrder,
        handleStartOrderAndUpdateOrder,
        handleCloseOrder,
        order
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  return useContext(CartContext);
};